<template>
    <button class="deposit-button">
        <div class="state-layer">
            <span class="label">{{tokens.fullScreen.withdrawal}}</span>
            <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M21 21V19H3L3 21H21Z" fill="#003930"/>
                <path d="M10.6716 4.5L10.7246 6.49758H14.3309L7.5 13.7427L9 15.2427L15.7451 7.91179L15.7451 11.518L17.7426 11.5711V4.5H10.6716Z" fill="#003930"/>
            </svg>

        </div>
    </button>
</template>

<script>
import {mapGetters} from "vuex"

export default {
    name: "BaseDepositButton",
    computed: {
        ...mapGetters(['tokens'])
    }
}
</script>

<style scoped>
.deposit-button {
    border-radius: var(--Corner-Extra-small);
    background: var(--System-Tertiary);
    color: var(--System-OnTertiary);
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
}

.deposit-button .state-layer {
    padding: 8px 16px;
}

.deposit-button:hover .state-layer {
    background: var(--Statelayers-ontertiary-opacity08, rgba(0, 57, 48, 0.08));
}

.deposit-button:focus-visible .state-layer {
    background: var(--Statelayers-ontertiary-opacity12, rgba(0, 57, 48, 0.08));
}

.deposit-button:active .state-layer {
    background: var(--Statelayers-ontertiary-opacity16, rgba(0, 57, 48, 0.08));
}

.icon {
    display: none;
}

.deposit-button svg path {
    fill: var(--System-OnTertiary);
}

@media (max-width: 767px) {
    .deposit-button .state-layer {
        padding: 6px;
    }

    .icon {
        display: block;
    }

    .label {
        display: none;
    }
}
</style>
